import React, { useState, useEffect, useContext, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, Form } from 'reactstrap';
import RhAdministracionService from '../../axios_services/rh_administracion.service';
import ArchivosService from '../../axios_services/archivos.service';
import Loader from '../Loader/Loader';
import { AppContext } from '../../application/provider';

const ModalEstadoPagoRhAdministracion = ({ isOpen, onClose, onRefresh, item, periodo }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [tipo_pagos] = useState(state.catalogos.tipos.filter(t => t.categoria_id == 32));
    
    const [fechaPago, setFechaPago] = useState('');
    const [pagoId, setPagoId] = useState('');
    const [comprobanteFile, setComprobanteFile] = useState(null);
    
    const fileComprobanteRef = useRef(null);

    const userProfile = Number(state.user?.perfil_id);
    const canUseActions = [8, 21, 12, 26].includes(userProfile);

    useEffect(() => {
        if (isOpen && item) {
            setFechaPago(item.fecha_pago || '');
            setPagoId(item.estado_pago_id || '');
            setComprobanteFile(null);
            if (fileComprobanteRef.current) fileComprobanteRef.current.value = '';
        }
    }, [isOpen, item]);

    if (!item) return null;

    const handleRegistrar = async () => {
        setIsLoading(true);
        try {
            await RhAdministracionService.actualizarPago({
                rh_administracion_id: item.rh_administracion_id,
                fecha_pago: fechaPago || null,
                estado_pago_id: pagoId || null,
            });

            if (comprobanteFile && canUseActions) {
                try {
                    await ArchivosService.guardarComprobantePago(comprobanteFile, item.rh_administracion_id, periodo, state.user.usuario_id);
                } catch (uploadError) {
                    const errorMsg = uploadError.response?.data?.message || '';
                    if (errorMsg.includes('failed to upload')) {
                        throw new Error('El archivo PDF pesa demasiado. (límite 2MB).');
                    }
                    throw uploadError;
                }
            }

            alert('Estado, fecha de pago y documentos actualizados correctamente.');
            if (onRefresh) onRefresh();
            onClose();
        } catch (e) {
            console.error(e);
            alert('Error al actualizar.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="md" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>ESTADO DE PAGO - RH</h1>
                    <button className="close-btn" onClick={onClose}>X</button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    {isLoading && <Loader />}
                    
                    <Form onSubmit={(e) => { e.preventDefault(); handleRegistrar(); }} className="px-4">
                        <FormGroup className="mb-4">
                            <Label>Estado de Pago:</Label>
                            <Input type="select" className="form-control" value={pagoId} onChange={(e) => setPagoId(e.target.value)} disabled={!canUseActions}>
                                <option value="">Seleccione un estado...</option>
                                {tipo_pagos.map(t => (
                                    <option key={t.tipo_id} value={t.tipo_id}>{t.descripcion}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-4">
                            <Label>Fecha de Pago:</Label>
                            <Input type="date" className="form-control" value={fechaPago} onChange={(e) => setFechaPago(e.target.value)} disabled={!canUseActions} />
                        </FormGroup>

                        <FormGroup className="mb-4">
                            <Label>Subir/Actualizar Comprobante de Pago (PDF):</Label>
                            <div className="cap-upload-zone">
                                <span className="cap-upload-btn" onClick={() => fileComprobanteRef.current?.click()}>
                                    {comprobanteFile ? comprobanteFile.name : 'Seleccionar archivo (PDF)'}
                                </span>
                                <input
                                    ref={fileComprobanteRef}
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={(e) => setComprobanteFile(e.target.files[0] || null)}
                                />
                            </div>
                            {comprobanteFile && (
                                <small>
                                    <span style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }} onClick={() => { setComprobanteFile(null); if (fileComprobanteRef.current) fileComprobanteRef.current.value = ''; }}>
                                        ✕ Quitar selección
                                    </span>
                                </small>
                            )}
                            {item.comprobante_url && !comprobanteFile && (
                                <small className="text-success mt-1 d-block">
                                    ✓ Ya existe un comprobante subido.{' '}
                                    <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => window.open(item.comprobante_url, '_blank')}>Ver documento</span>
                                </small>
                            )}
                        </FormGroup>

                        <div className="flex justify-end mt-4 pb-3">
                            <Button className="btn-primary px-5 py-2" onClick={handleRegistrar} style={{ borderRadius: '8px' }} disabled={isLoading || !canUseActions}>
                                GUARDAR CAMBIOS
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalEstadoPagoRhAdministracion;
